import { PatientService } from "@/services/api/patient.api.service"
import {copyObject} from "@/extensions/prototypes/prototypes"
import {deductToothViewFromTeeth} from "@/services/teeth.helper"

const state = {
    teeth: [],
    selectedTooth: null, // for patient general formula
    selectedToothArea: null, // for patient general formula
    selectedToothAreas: [], // for patient general formula
    sameGroupSelectedTooth: false,
    isShiftPressed: false,
    selectedToothSelectionType: 'status',
    // recordTeeth: [], // record teeth for specific visit (ids)
    toothStatuses: {}, // dictionary
    templates: [],
    visitResults: [],
    fieldConfigs: [],
    passedPatientFormulaView: null
}

const getters = {
    keyedFieldConfigs(state) {
        let maxOrder = 1
        const obj = {
            description: {
                order: 0,
                active: true
            }
        }
        for (const fc of state.fieldConfigs) {
            if(fc.category === 'description') {
                maxOrder = Math.max(maxOrder, fc.sort_order)
                obj[fc.field_name] = {
                    order: fc.sort_order,
                    active: fc.active
                }
            }
        }
        obj['epikriz'] = {
            order: (maxOrder + 1),
            active: true
        }
        return obj
    },
    keyedFieldConfigsGeneral(state) {
        const obj = {}
        for (const fc of state.fieldConfigs) {
            if(fc.category === 'teeth_general') {
                obj[fc.field_name] = {
                    order: fc.sort_order,
                    active: fc.active
                }
            }
        }
        return obj
    }
}

const mutations = {
    setTeeth(state, teeth) {
        state.teeth = teeth
    },
    setSelectedTooth(state, params) {
        state.selectedTooth = state.selectedTooth == params.tooth ? null : params.tooth
        state.selectedToothArea = params.area
        state.selectedToothAreas = params.areas || []
        if(params.type) {
            state.selectedToothSelectionType = params.type
        }
    },
    setStatuses(state, statuses) {
        state.toothStatuses = statuses
    },
    setTemplates(state, value) {
        state.templates = value
    },
    setFieldConfigs(state, value) {
        state.fieldConfigs = value
    },
    setVisitResults(state, value) {
        state.visitResults = value
    },
    setPassedPatientFormulaView(state, value) {
        state.passedPatientFormulaView = value
    }
}

const actions = {
    getPatientTeeth(context, id) {
        return new Promise((resolve, reject) => {
            PatientService.getClientTeeth(id).then(data => {
                const d = data.data
                context.commit('setTeeth', d.teeth)
                context.commit('setStatuses', d.statuses)
                resolve(d)
            }).catch(err => {
                reject(err.response.data.errors)
            })
        })
    },
    async removeTooth(context, params) {
        const tooth = params.tooth
        const serviceIdsWithLabServicesAttached = (context.rootState?.patient?.visit.laboratoryServices || []).map(a => a.service_id)

        let ind = context.state.recordTeeth.indexOf(tooth)
        if (ind !== -1) {
            const services = Object.values(context.rootState?.treatment?.services || {})
            for(const service of services) {
                if ((service.teeth || []).includes(tooth)) {
                    if(serviceIdsWithLabServicesAttached.includes(service.id)) {
                        params.app.$noty.error(params.app.$t('cannot_change_services_that_already_have_laboratory_services_attached'))
                        return
                    }
                }
            }
            const diagnoses = Object.values(context.rootState?.treatment?.diagnoses || {})
            for(const diagnosis of diagnoses) {
                if((diagnosis.teeth || []).includes(tooth)) {
                    diagnosis.teeth = diagnosis.teeth.filter(t => t !== tooth)
                    if(diagnosis.teeth.length === 0 && diagnosis.id) {
                        context.commit('deleteDiagnosis', diagnosis.id)
                    }
                }
            }
            for(const service of services) {
                if((service.teeth || []).includes(tooth)) {
                    await context.dispatch('quantityChangedManually', {
                        service_id: service.id,
                        sign: 'minus',
                        teeth: copyObject(service.teeth),
                        new_tooth: tooth,
                        qty: service.pivot?.amount || 1
                    })
                }
                const leftTeeth = copyObject(context.rootState?.treatment?.services?.[service.id]?.teeth || [])
                if(!leftTeeth.length) context.commit('deleteService', service.id)
            }
            context.state.recordTeeth.splice(ind, 1)
        }
    },
    decideWhichPatientFormulaViewToShow(context, params) {
        const visits = params.plan?.visits || []
        const teeth = [...new Set(visits.map(visit => (visit.teeth || []).map(t => t.tooth)).flat())]
        context.commit('setPassedPatientFormulaView', deductToothViewFromTeeth(teeth))
    }
};

export default {
    state,
    actions,
    mutations,
    getters
}
